export default function renderDate(date: Date) {
  return isNaN(date.getTime())
    ? ''
    : date.toLocaleDateString('en-gb')
}